export const queryKey = {
  PORTAL: "portal",
} as const;
